// removed by extract-text-webpack-plugin
module.exports = {"content":"src-templates----university-module---content---1R-l9","courseListing":"src-templates----university-module---courseListing---3lDek"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/university.module.css
// module id = 682
// module chunks = 75089604999211